import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Table} from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';

class ModalSection extends Component{
	constructor(props){
		super(props);

		this.handleShow  = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onSave 	 = this.onSave.bind(this);
		this.verifyCheck = this.verifyCheck.bind(this);

		this.state = {
			show: false,
			options:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);


	}

	handleShow(){
		this.setState({
			show: true
		});

		var opt = []
		this.props.state.lab_sections.map((lab)=>{
			opt.push({value:lab.lab_sections_id, name:lab.name, check:false})
		})

		this.setState({
			options: opt
		});

	}

	handleClose(){
		this.setState({
			show: false
		})
	}

	onSave(){
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');

		var num_check = "";
		ctrls.forEach(ctrl => {
	    	if(ctrl.checked){
	    		if(num_check == ""){
	    			num_check = ctrl.value;
	    			this.props.getSections(num_check);
	    			this.handleClose();
	    		}
	    	}
	    });
	}

	verifyCheck(e){
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');
		var options = this.state.options;

		var num_check = "";
		ctrls.forEach((ctrl, i) => {
	    	if(ctrl.name == e.target.name){
	    		if(ctrl.checked){
	    			options[i].check = true;
	    		}
			}else{
				if(ctrl.checked){
	    			options[i].check = false;
	    		}
			}
	    });

	    this.setState({
			options: options
		})
	}

	render(){
		const {t} = this.props;

		return (
			<Modal show={this.state.show} onHide={this.handleClose} backdrop="static" keyboard={false}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Secciones - Listas de trabajo</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >

		        	{this.props.state.lab_sections.length > 1 ?
		        		<Table responsive hover>
		        			<thead>
		        				<tr>
			        				<th>Sección</th>
			        				<th></th>
		        				</tr>
		        			</thead>
		        			<tbody>
		        				{this.state.options.map((section, i)=>(
		        					<tr key={section.value}>
		        						<td>{section.name}</td>
		        						<td>
		        							<input type="checkbox" name={'section_'+section.value} 
		        								id={'section_'+section.value} value={section.value} 
		        								onChange={this.verifyCheck}
		        								checked={section.check} />
		        							</td>
		        					</tr>
		        				))

		        				}
		        			</tbody>
		        		</Table>
		        	:null
		        	}
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.select')} onClick={this.onSave} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalSection);